import { FeatureClientPlatform } from './context';
import { FeatureStage } from './types';

/**
 * Declarative gating metadata attached to registry entries.
 * Not enforced until matching resolvers are registered in the evaluator pipeline.
 */
export interface FeatureRequirements {
  /** Limit availability to specific client platforms. */
  platforms?: FeatureClientPlatform[];
  /** Future: require one of these subscription tiers. */
  subscriptionTiers?: string[];
  /** Future: require one of these creator plan tiers. */
  creatorPlans?: string[];
  /** Future: require enrollment in one of these beta programs. */
  betaPrograms?: string[];
  /** Future: restrict to internal testing cohorts. */
  internalOnly?: boolean;
  /** Minimum rollout stage before the feature can be enabled. */
  minStage?: FeatureStage;
}
